module.exports = __webpack_public_path__ + "img/share-svgrepo-com.092e3ad3.svg";